import { render, staticRenderFns } from "./channel-program.vue?vue&type=template&id=1baf2024&scoped=true&lang=pug"
import script from "./channel-program.vue?vue&type=script&lang=js"
export * from "./channel-program.vue?vue&type=script&lang=js"
import style0 from "./channel-program.vue?vue&type=style&index=0&id=1baf2024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baf2024",
  null
  
)

export default component.exports